import { PagePartHolder } from '../../PagePartHolder';

export const ActionbarHolder = (props) => {
  return <PagePartHolder {...props} outlet="action" />;
};
